import React from "react";

export const Cabecalho = ({ rotulo, titulo, texto, claro }) => (
  <>
    <p className={`text-sm font-semibold uppercase tracking-widest mb-4 xl:text-center ${claro ? "text-white/70" : "text-pattern-dark"}`}>{rotulo}</p>
    <h2 className={`text-3xl xl:text-5xl font-semibold xl:text-center ${texto ? "mb-6" : "mb-12 xl:mb-20"}`}>{titulo}</h2>
    {texto ? <p className={`text-xl leading-relaxed xl:text-center xl:w-2/3 xl:mx-auto mb-12 xl:mb-20 ${claro ? "text-white/75" : "text-gray-700"}`}>{texto}</p> : null}
  </>
);

export const Faixa = ({ fundo, anterior, proximo, children }) => {
  if (fundo === "blue") {
    return (
      <div>
        <div className={`fade-${anterior}-to-blue`} aria-hidden="true" />
        <div className="bg-pattern-fade text-white">
          <div className="w-3/4 mx-auto xl:py-48 py-24">{children}</div>
        </div>
        <div className={`fade-blue-to-${proximo}`} aria-hidden="true" />
      </div>
    );
  }
  const miolo = <div className="text-black w-3/4 mx-auto xl:py-32 py-16">{children}</div>;
  if (fundo === "white") return <div className="bg-white">{miolo}</div>;
  return (
    <div>
      {anterior === "white" ? <div className="fade-white-to-gray" aria-hidden="true" /> : null}
      <div className="bg-gray-50">{miolo}</div>
      {proximo === "white" ? <div className="fade-gray-to-white" aria-hidden="true" /> : null}
    </div>
  );
};

export const fundosAlternados = (quantidade) => Array.from({ length: quantidade }, (_, indice) => (indice % 2 === 0 ? "white" : "gray"));
